import { atom } from 'jotai'

const lang = atom('')

export const Atom = {
  lang,
}
